module.exports = __webpack_public_path__ + "img/Inflammation-PRCA_10X_ACC.328c81d3.png";